module.exports = __webpack_public_path__ + "media/Video 112.5112df9f.mp4";